<template>
	<div class="white pos-rel rounded-lg min-h-screen">
		<div class="header">
			<div>Invite Creator to Agency</div>
		</div>
		<v-btn
			fab
			flat
			class="top-left-align pa-0 ma-0 pt-1"
			@click="closeModal"
		>
			<v-icon>close</v-icon>
		</v-btn>
		<v-container class="pa-4 container">
			<v-layout class="mb-2">
				<v-flex class="text-field-wrapper py-1 px-1 mx-0">
					<v-text-field
						v-model="hostDetails.handle"
						label="Host Moj Handle*"
						placeholder="Host Moj Handle"
						class="text-field-wrapper ma-0 pt-4"
						required
					/>
				</v-flex>
			</v-layout>
			<v-layout class="mb-2">
				<v-flex class="text-field-wrapper py-1 px-1 mx-0">
					<v-text-field
						v-model="hostDetails.hostName"
						label="Host Name"
						placeholder="Host Name"
						class="text-field-wrapper ma-0 pt-4"
						:rules="[validHostName]"
					/>
				</v-flex>
			</v-layout>
			<v-layout class="mb-2">
				<v-flex class="text-field-wrapper py-1 px-1 mx-0">
					<v-text-field
						v-model="hostDetails.phone"
						label="Host Phone Number*"
						placeholder="Host Phone Number"
						class="text-field-wrapper ma-0 pt-4"
						required
						:rules="[validPhoneNoRule]"
					/>
				</v-flex>
			</v-layout>
			<v-layout class="mb-2">
				<v-flex class="text-field-wrapper py-1 px-1 mx-0">
					<v-text-field
						v-model="hostDetails.age"
						label="Host Age*"
						placeholder="Host Age"
						class="text-field-wrapper ma-0 pt-4"
						required
						:rules="[ageRule(hostDetails.age, 18, 100)]"
					/>
				</v-flex>
			</v-layout>
			<v-layout row class="mb-2">
				<v-flex>
					<v-select
						:items="genderOptions"
						item-text="value"
						item-value="key"
						label="Host Gender*"
						placeholder="Host Gender"
						class="body-1 text-field-wrapper pt-4"
						v-model="hostDetails.gender"
						:value="hostDetails.gender"
						required
					></v-select>
				</v-flex>
			</v-layout>
			<v-layout row class="mb-2">
				<v-flex>
					<v-select
						:items="languageOptions"
						label="Host Language*"
						placeholder="Host Language"
						class="body-1 text-field-wrapper pt-4"
						v-model="hostDetails.language"
						:value="hostDetails.language"
						required
					></v-select>
				</v-flex>
			</v-layout>
			<v-layout class="mb-2">
				<v-flex class="text-field-wrapper py-1 px-1 mx-0">
					<v-text-field
						v-model="hostDetails.instagramUrl"
						label="Instagram Profile"
						placeholder="Instagram Profile"
						class="text-field-wrapper ma-0 pt-4"
						:rules="[
							hostDetails.instagramUrl === '' ||
								hostDetails.instagramUrl.includes(
									'instagram.com/'
								) ||
								'Not a valid Instagram URL'
						]"
					/>
				</v-flex>
			</v-layout>
			<v-layout class="d-flex justify-space-between">
				<v-btn
					class="mx-0 mr-4 white--text btn rounded-pill"
					:color="themeInputColor"
					@click="sendInvite"
					:disabled="!isInputValidMoj"
					>Continue</v-btn
				>
				<v-btn
					class="btn rounded-pill"
					color="error"
					outline
					@click="closeModal"
					>Cancel</v-btn
				>
			</v-layout>
		</v-container>
	</div>
</template>

<script>
import { _validPhoneNoRule, _ageRule, _checkValidHostName } from "@/utils";

export default {
	name: "InviteCreator",
	props: ["themeInputColor", "model", "triggerDataReset", "loading"],
	data() {
		return {
			validPhoneNoRule: _validPhoneNoRule,
			ageRule: _ageRule,
			validHostName: _checkValidHostName,
			searchOptions: [
				{ key: "phoneNo", value: "Phone No" },
				{ key: "email", value: "Email" },
				{ key: "handle", value: "Handle" }
			],
			genderOptions: [
				{ key: "M", value: "Male" },
				{ key: "F", value: "Female" },
				{ key: "O", value: "Other" }
			],
			languageOptions: [
				"English",
				"Hindi",
				"Punjabi",
				"Malayalam",
				"Telugu",
				"Tamil",
				"Bengali",
				"Marathi",
				"Kannada",
				"Gujarati",
				"Odia",
				"Bhojpuri",
				"Haryanvi",
				"Rajasthani",
				"Assamese"
			],
			genreOptions: [
				"Dance Performance",
				"Music Performance",
				"Magic Performance",
				"Arts, Crafts & DIY",
				"Photography",
				"Comedy & Fun",
				"Romance & Heartbreak",
				"Motivation",
				"Attitude",
				"Sadness / Pain",
				"Anger",
				"Kindness",
				"Other Emotional Video",
				"Movies",
				"Web Series",
				"TV Shows",
				"Celebrity",
				"Entertainment News",
				"Cartoons Shows & Anime",
				"Songs, Albums & Concerts"
			],
			hostDetails: {
				handle: "",
				hostName: "",
				phone: "",
				age: "",
				gender: "",
				language: "",
				instagramUrl: ""
			}
		};
	},
	computed: {
		isInputValidMoj() {
			if (
				!this.hostDetails.handle ||
				!this.hostDetails.phone ||
				(this.hostDetails.phone &&
					this.validPhoneNoRule(this.hostDetails.phone) !== true) ||
				!this.hostDetails.age ||
				(this.hostDetails.age &&
					this.ageRule(this.hostDetails.age, 18, 100) !== true) ||
				!this.hostDetails.gender ||
				!this.hostDetails.language ||
				(this.hostDetails.instagramUrl &&
					!this.hostDetails.instagramUrl.includes("instagram.com/"))
			) {
				return false;
			}
			return true;
		}
	},
	methods: {
		resetData() {
			this.hostDetails = {
				handle: "",
				phone: "",
				age: "",
				gender: "",
				language: "",
				instagramUrl: "",
				hostName: ""
			};
		},
		closeModal() {
			this.resetData();
			this.$emit("CLOSE_INVITE_MODAL", this.model);
		},
		sendInvite() {
			this.$emit("INVITE_CREATOR", this.hostDetails);
		}
	},
	watch: {
		triggerDataReset: function() {
			this.resetData();
		}
	}
};
</script>

<style lang="scss" scoped>
.header {
	border-radius: 16px 16px 0 0;
	background-color: #edf0f7;
	color: #233b5d;
	font-weight: 500;
	font-size: 20px;
	line-height: 21px;
	padding: 1em;
	text-align: center;
	letter-spacing: 0.004em;
}
.container {
	max-width: 600px;
}
</style>
